<template>
  <div>
    <div class="content">
      <Header/>
      <v-container>
        <v-layout align-center justify-center>
          <v-flex lg12 md12 sm12 xs12>
            <v-row justify-center>
              <v-col>
                <p class="text-center">Your session has expired !!</p>
              </v-col>
            </v-row>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
    <Footer/>
  </div>
</template>

<script>
import Header from "../HeaderPrelogin";
import Footer from "../core/Footer";

export default {
  name: "invalidSession",
  components: {Header, Footer}
}
</script>
